import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  changeLoadingState,
  dispatch,
  setCoachLogin,
  setCoachLogout,
  setCoachProfile,
  setErrorMessage,
  setGymState,
  setCoachState,
  setSuccessMessage,
  deleteCoachState,
  addCoachState,
} from "../redux";

export const coachLoginService = async (email, password) => {
  try {
    dispatch(changeLoadingState(true));
    const resp = await httpClient().patch(ApiEndpoints.coachLogin, {
      email,
      password,
    });

    if (!resp.data.success && resp.status >= 201) {
      throw new Error(resp.data.message);
    }

    dispatch(setCoachLogin(resp.data.result.token));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(changeLoadingState(false));
    dispatch(setErrorMessage(error.message));
  }
};
export const createCoachService = async (formData) => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));
    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.createCoachAccount, {
      ...formData,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addCoachState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
export const getCoachs = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getCoach, {
      params: {
        page,
        limit,
        // name: search,
        // sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setCoachState({ coachs: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};

export const deleteCoach = async (id) => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().delete(ApiEndpoints.deleteCoach + "/" + id);
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteCoachState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
export const forgetCoachPasswordService = async (email) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.forgetCoachPassword, {
      email,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const changeCoachProfileService = async (formData) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.changeCoachProfile, {
      ...formData,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setCoachProfile(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
export const changeCoachPasswordService = async (
  // token,
  currentPassword,
  newPassword
) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.changeCoachPassword, {
      // token,
      currentPassword,
      newPassword,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
export const changeCoachEmailService = async (
  // token,
  // currentEmail,
  newEmail
) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.changeCoachEmail, {
      email: newEmail,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
export const resetCoachPasswordService = async (token, password) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.resetCoachPassword, {
      token,
      password,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const getCoachProfile = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.coachProfile);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setCoachProfile(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

/**
 * To logout coach
 */
export const logoutCoach = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // Update to Store
    dispatch(setCoachLogout());
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

// for geting the gyms
export const getGyms = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getGyms, {
      params: {
        page,
        limit,
        // name:search,
        // sort
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setGymState({ gyms: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
